import { getStore } from '../store/store';
import { locationChanged, openAttachmentFolderPicker } from '../actions/internalActions';
import { mutator } from 'satcheljs';

mutator(locationChanged, actionMessage => {
    const { result } = actionMessage;

    getStore().folderSelectorResult = result;
});

mutator(openAttachmentFolderPicker, () => {
    getStore().folderSelectorResult = null;
});
